import { GAME_ID, REDUX_ACTIONS, LEVEL_COUNT, ITEM_MASTERY_THRESHOLD } from '../../data/constants';

/**
  * example object in correctAnswers array:
  * {
  *    color: '#4B8402',
  *    text: 'setting',
  *    description: 'Setting is where the story takes place',
  *    isCorrect: true
  *  }
  */

const initialState = {
  correctAnswers: [],
  masteredItemsCount: 0,
  highestLevelUnlocked: 0,
};

const masteryReducer = (state = initialState, { type, payload, gameId }) => {
  if (gameId !== GAME_ID) {
    return state;
  }

  switch (type) {
    case REDUX_ACTIONS.SET_LEVEL_ID: {
      return {
        ...state,
        correctAnswers: [],
        masteredItemsCount: 0,
      };
    }

    case REDUX_ACTIONS.INITIALIZE_ROUND:
      return {
        ...state,
        correctAnswers: payload.correctAnswers,
        failedQuestionIds: [],
        masteredItemsCount: payload.masteredItemsCount,
      };

    case REDUX_ACTIONS.SELECT_RESPONSE: {
      const correctAnswers = [...state.correctAnswers];
      const { response, attemptNumber, isCorrect } = payload;

      Object.keys(response).forEach((key) => {
        if (response[key] !== undefined) {
          // If this is your first _or_ second try, add the response to the list of correct answers
          if (attemptNumber <= ITEM_MASTERY_THRESHOLD && response[key].isCorrect) {
            correctAnswers.push(response[key]);
          }
        }
      });

      return {
        ...state,
        correctAnswers,
        masteredItemsCount: isCorrect && (attemptNumber <= 2)
          ? state.masteredItemsCount + 1
          : state.masteredItemsCount,
      };
    }
    case REDUX_ACTIONS.QUICK_ROUND: {
      const correct = payload.pass ? payload.number : 0;
      return {
        ...state,
        masteredItemsCount: correct,
      };
    }

    case REDUX_ACTIONS.TRY_UNLOCK_NEXT_LEVEL: {
      const highestLevelUnlocked = Math.min(payload, LEVEL_COUNT - 1);
      return {
        ...state,
        highestLevelUnlocked,
      };
    }

    default:
      return state;
  }
};

export default masteryReducer;
